import { RawStepType } from '../interfaces/step-type.interface';

export class StepType {
  private readonly _rawData: RawStepType;

  public get steptypeId() { return this._rawData.steptypeId; }
  public get name() { return this._rawData.name; }
  public get modifiesEnv() { return this._rawData.modifiesEnv; }
  public get executable() { return this._rawData.executable; }
  public get headless() { return this._rawData.headless; }
  public get fileExt() { return this._rawData.fileExt; }
  public get description() { return this._rawData.description; }

  constructor(data: RawStepType) {
    this._rawData = data;
  }

  // The only step types are Markdown (1), JavaScript (2), and Python (3),
  // identified by their authoritative database steptype_id.
  public get isMarkdown() {
    return this.steptypeId === 1;
  }

  public get isJavascript() {
    return this.steptypeId === 2;
  }

  public get isPython() {
    return this.steptypeId === 3;
  }

  public get outputIsFromCode() {
    return this.isJavascript || this.isPython;
  }

  public get outputIsHtml() {
    return this.isMarkdown;
  }

  public get supportsFullscreenOutput() {
    return true;
  }
}
